/* tslint:disable */
/* eslint-disable */
export enum WorkOrderCriteria {
  DebtorContactNumberNotFound = 'DEBTOR_CONTACT_NUMBER_NOT_FOUND',
  OrderStateNotDisbursementsEntered = 'ORDER_STATE_NOT_DISBURSEMENTS_ENTERED',
  DuplicateOrderKey = 'DUPLICATE_ORDER_KEY',
  CurrencyNotFound = 'CURRENCY_NOT_FOUND',
  UnexpectedIssueFound = 'UNEXPECTED_ISSUE_FOUND',
  NetAmountExceedsTotalAmount = 'NET_AMOUNT_EXCEEDS_TOTAL_AMOUNT',
}
